import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MODAL_DIRECTIVES } from './modal-control/index';
import { ModalDialogService } from './modal-dialog/modal-dialog-service/modal-dialog.service';
import { ModalDialog } from './modal-dialog/modal-dialog-component/modal-dialog.component';
import { SvgIconsModule } from '@nx-fe/icons';
import { PipesModule } from '@nx-fe/pipes';
import { TooltipModule } from '@soti/tooltip';

@NgModule({
  imports: [CommonModule, SvgIconsModule, PipesModule, TooltipModule],
  declarations: [MODAL_DIRECTIVES, ModalDialog],
  exports: [MODAL_DIRECTIVES, ModalDialog],
})
export class SharedDialogsModule {
  static forRoot(): ModuleWithProviders<SharedDialogsModule> {
    return {
      ngModule: SharedDialogsModule,
      providers: [ModalDialogService],
    };
  }
}
